import React, { useState, Fragment, useRef, createContext, useEffect } from 'react';
import { Stage, Layer, Image} from 'react-konva';
import {Stack, Button, Tooltip, Grid} from '@mui/material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';

import Linea from './Figuras/Linea';
import ImagenURL from './Figuras/ImagenURL';
import NodoComponent from './Figuras/NodoComponent';

import PanelComponent from './Lienzo/PanelComponent';
import ImportarArchivo from '../Functions/ImportarArchivo';
import ExportarArchivo from '../Functions/ExportarArchivo';
import ExportarPNG from '../Functions/ExportarPNG';
import ExportarPDF from '../Functions/ExportarPDF';
import SubirImagen from '../Functions/SubirImagen';

import {v4} from 'uuid'
import GuardarDiagrama from '../Functions/GuardarDiagrama';

function distancia(p1,p2) {
    const x = p1.x - p2.x
    const y = p1.y - p2.y
  
    return Math.sqrt(x * x + y * y)
}

const LienzoDiagrama = (props) => {

    const {arrayNodos, arrayLineas, diagramaId, diagramaTitulo, diagramaFecha, diagramaCole} = props;
    //Referencia del stage
    const stageRef = useRef(null);
    const layerRef = useRef(null);

    //UseState o Arreglo del WorkSpace para exportar
    const [workSpace, setWorkSpace] = useState([]);

    const [idDiagrama, setIDiagrama] = useState(diagramaId);
    
    //Componentes rectangulo
    const [rectangulos, setRectangulos] = useState([]);
    const [position, setPosition] = useState(0);

    //Componentes imagen
    const [imagenes, setImagenes] = useState([]);

    //Componentes Nodo
    const [nodos, setNodos] = useState(arrayNodos);
    const [numeroNodo, setNumeroNodo] = useState(0);

    //Puntos linea
    const [clickCount, setClickCount] = useState(true);
    const [listaPuntos, setListaPuntos] = useState([]);
    const [lineas, setLineas] = useState(arrayLineas);
    const [lineaRectId, setLineaRectId] = useState([]);
    const [positionLine, setPositionLine] = useState(0);

    //Botones de figuras
    const [isCreateRect, setIsCreateRect] = useState(false);
    const [isCreateEllipse, setIsCreateEllipse] = useState(false);
    const [isCreateLine, setIsCreateLine] = useState(false);

    //Variables que componen el stages
    //Usadas en la funcion de zoom in & zoom out
    const [stageScale, setStageScale] = useState(1);
    const [stageX, setStageX] = useState(0);
    const [stageY, setStageY] = useState(0);
    const [myStage, setMyStage] = useState(null)

    //Variables para editar figura
    const [selectedShape, setSelectedShape] = useState(null);

    const checkDeselect = (e) => {
        // deselect when clicked on empty area
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
            setSelectedShape(null);
        }
      };


    const createNode = (e) =>{
        const stage = e.target.getStage();
        const oldScale = stage.scaleX();
        const mousePointTo = {
            x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
            y: stage.getPointerPosition().y /  oldScale - stage.y() / oldScale
        };

        try {
            const newNodo = {
                id: 'Nodo '+v4(),
                text: 'Doble click para editar ',
                x: mousePointTo.x-100,
                y: mousePointTo.y-25,
                isDragging: false,
                width: 200,
                height: 50,
                fontSize: 20,
                fill:'#93FA5C',
                contorno:'#74AC57',
                strokeWidth:1,
                urlImagen: ''
            } 
            setNodos([...nodos, newNodo]);
            setNumeroNodo(numeroNodo+1);
        } catch (error) {
            
        }
    }
    


    //Funcion para crear una linea
    const createLine = (e) =>{

        const idObjeto = e.target.attrs.id;
        if(idObjeto !== undefined){
            /* console.warn('No puede crear objeto sobre otro') */
            if(idObjeto.includes('Nodo')){

                if(true){
                    if(clickCount){
                        listaPuntos.push(e.target.attrs.x);
                        listaPuntos.push(e.target.attrs.y);
                        lineaRectId.push(e.target.attrs.id);
                        setClickCount(false);
                    }else{
                        listaPuntos.push(e.target.attrs.x);
                        listaPuntos.push(e.target.attrs.y);
                        lineaRectId.push(e.target.attrs.id);
                        try {
                            const newLine = {
                                id: 'Line'+positionLine.toString(),
                                vertices: listaPuntos,
                                isDragging: false,
                                rectangulosLinea: lineaRectId,
                            }
                            setLineas([...lineas, newLine]);
                            setPositionLine(positionLine+1);
                            
                        }catch (error) {
                            // console.log(error)
                        }
                        setClickCount(true);
                        setListaPuntos([]);
                        setLineaRectId([]);
                    }
                }
            }
            else{
                if(isCreateLine){
                    if(clickCount){
                        listaPuntos.push(e.target.attrs.x+80);
                        listaPuntos.push(e.target.attrs.y+35);
                        lineaRectId.push(e.target.attrs.id);
                        setClickCount(false);
                    }else{
                        listaPuntos.push(e.target.attrs.x+80);
                        listaPuntos.push(e.target.attrs.y+35);
                        lineaRectId.push(e.target.attrs.id);
                        try {
                            const newLine = {
                                id: 'Line'+positionLine.toString(),
                                vertices: listaPuntos,
                                isDragging: false,
                                rectangulosLinea: lineaRectId,
                            }
                            setLineas([...lineas, newLine]);
                            setPositionLine(positionLine+1);
                            
                        }catch (error) {
                            // console.log(error)
                        }
                        setClickCount(true);
                        setListaPuntos([]);
                        setLineaRectId([]);
                    }
                }
            }
        }else{
            /* console.log('Objeto es undefined') */
        }
        
        
    }

    //Funcion para generar un accion al hacer click
    const handleClick = (e) =>{

        const stage = e.target.getStage();
        const oldScale = stage.scaleX();
        const mousePointTo = {
            x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
            y: stage.getPointerPosition().y /  oldScale - stage.y() / oldScale
        };
        // console.log(mousePointTo)
        // console.log(e.target.attrs)

    }

    const mostrarDistancia = (e) =>{
        nodos.forEach((nodo) => {
            console.log(nodo.x, nodo.y, nodo.id)
        });
    }
    


    const clearWorkSpace = () =>{
        setWorkSpace([]);
        setPosition([]);

        setClickCount(0);

        setListaPuntos([]);
        setLineaRectId([]);
        
        setPositionLine(0);
        setLineas([]);

        setNodos([{
            "id":"Nodo-420ac788-1195-464d-8b1f-660bb7f46bb4",
            "text":"Elemento inicial",
            "x":window.innerWidth/2-100,
            "y":window.innerHeight/2-25,
            "isDragging":false,
            "width":200,
            "height":50,
            "fontSize":20,
            "align": 'center',
            "fontStyle":'bold',
            "verticalAlign": 'middle',
            "textFill": '#000000',
            "fill":"#9E9D91",
            "contorno":"#000000",
            "strokeWidth":1,
            "urlImagen": '',
            "imgId": '',
            "imgWidth": 200,
            "imgHeight": 50,
            "tieneImagen": false
        }]);
    }

    
    //Evento para hacer zoom in & zoom out en el stage
    const handleWheel = (e) =>{
        e.evt.preventDefault();

        const scaleBy = 1.05;
        const stage = e.target.getStage();
        const oldScale = stage.scaleX()
        
        const mousePointTo = {
            x: stage.getRelativePointerPosition().x / oldScale - stage.x() / oldScale,
            y: stage.getRelativePointerPosition().y /  oldScale - stage.y() / oldScale
        };

        const newScale = e.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;

        setStageScale(newScale);
        setStageX(-(mousePointTo.x - stage.getRelativePointerPosition().x / newScale) * newScale)
        setStageY(-(mousePointTo.y - stage.getRelativePointerPosition().y / newScale) * newScale)
        

    }

    //Para el historial de movimiento
    const [historial, setHistorial] = useState([nodos]);
    const [historyStep, setHistoryStep] = useState(0)
    
    const hanldeMove = (e) =>{
        setStageX(
            e.target.attrs.x
        )
        setStageY(
            e.target.attrs.y
        )
    }

    return (
        <div>
            <Fragment >
                <Stack spacing={1} direction="row" /* justifyContent='center' alignItems='center' */>
                    
                    <Grid container spacing={1}>
                        <Grid item xs={6} md={6} display="flex" justifyContent="start" alignItems="start" >
                            
                            <div style={{ marginLeft: 5,}}>
                                <Tooltip title='Limpiar Workspace'>
                                    <Button onClick={clearWorkSpace} variant="outlined"> 
                                        <CleaningServicesIcon/>
                                    </Button>
                                </Tooltip>
                            </div>
                            
                            <div style={{ marginLeft: 4, marginRight: 30 }}>
                                <GuardarDiagrama
                                    nodos={nodos}
                                    lineas={lineas}
                                    idDiagrama={idDiagrama}
                                    diagramaTitulo={diagramaTitulo}
                                    diagramaFecha={diagramaFecha}
                                    diagramaCole={diagramaCole}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6} md={6} display="flex" justifyContent="end" alignItems="end">
                            <div style={{ marginLeft: 30 }}>
                                <ExportarPDF 
                                    stageRef={stageRef} 
                                    window={window}
                                    setStageX={setStageX}
                                    setStageY={setStageY}
                                    setStageScale={setStageScale}
                                    nodos={nodos}
                                />
                            </div>
                            <div style={{ marginLeft: 4 }}>
                                <ExportarPNG 
                                    stageRef={stageRef}
                                    setStageX={setStageX}
                                    setStageY={setStageY}
                                    setStageScale={setStageScale}
                                    nodos={nodos}
                                />
                            </div>
                            <div style={{ marginLeft: 4 }}>
                                <ExportarArchivo lineas={lineas} imagenes={imagenes} nodos={nodos}/>
                            </div>
                            <div style={{ marginLeft: 4, marginRight: 5 }}>
                                <ImportarArchivo clearWorkSpace={clearWorkSpace} setLineas={setLineas} setImagenes={setImagenes} setNodos={setNodos}/>
                            </div>
                        </Grid>
                    </Grid>
                </Stack>
                <br/>
                <Stage  
                    x={stageX}
                    y={stageY} 
                    width={window.innerWidth} 
                    height={window.innerHeight}
                    scaleY={stageScale} 
                    scaleX={stageScale}
                    ref={stageRef}
                    draggable
                    
                    onDragMove={()=>{}}
                    
                    // onClick={handleClick} 
                    // onTap={handleClick} 

                    /* 

                    --> Descomentar esto para crear
                    Nodos con el evento
                    dbClick <--

                    onDblTap={createNode}
                    onDblClick={createNode} */

                    onWheel={handleWheel}
                    
                    style={{backgroundColor:'#F7F5E2'}}
                    onMouseDown={checkDeselect}
                    onTouchStart={checkDeselect}
                >
                    <Layer> 
                        {lineas.map((line) =>(
                            <Linea key={line.id} {...line}/>
                        ))}

                        {nodos.map((nodo, i)=>(

                            <ImagenURL
                                key={i}
                                imgHeight={nodo.imgHeight}
                                imgWidth={nodo.imgWidth}
                                widthOriginal={nodo.widthOriginal}
                                heightOriginal={nodo.heightOriginal}
                                {...nodo}
                                urlImagen={nodo.urlImagen}
                                setImagenes={setImagenes}
                                imagenes={imagenes}
                                lineas={lineas}
                                tieneImagen={nodo.tieneImagen}
                                shapeProps={nodo}

                                isSelected={nodo.imgId === selectedShape}
                                onSelect={()=>{setSelectedShape(nodo.imgId)}}

                                onChange={(newAttrs)=>{
                                    const auxNodos = nodos.slice();
                                    auxNodos[i] = newAttrs;
                                    setNodos(auxNodos)
                                }}
                            />
                            
                        ))}
                        {nodos.map((nodo, i)=>(
                            <NodoComponent
                                key={nodo.id}
                                {...nodo}
                                shapeProps={nodo}

                                nodos={nodos}
                                setNodos={setNodos}

                                lineas={lineas}
                                setLineas={setLineas}

                                historial={historial}
                                setHistorial={setHistorial}
                                setHistoryStep={setHistoryStep}
                                historyStep={historyStep}

                                isSelected={nodo.id === selectedShape}
                                onSelect={()=>{setSelectedShape(nodo.id)}}
                                onChange={(newAttrs)=>{
                                    const auxNodos = nodos.slice();
                                    auxNodos[i] = newAttrs;
                                    setNodos(auxNodos)
                                }}
                                
                            />
                        ))}
                    
                    </Layer>
                </Stage>
            </Fragment>
            
        </div>
    )
}

export default LienzoDiagrama;